import { externalBaseUrl } from '../configs/constants';
import byebugAxios from './axiosInterceptor'

export const changePassword = (payload) => {
    return byebugAxios.post(`${externalBaseUrl}/users/change-password`, payload);
};